export const CONNECTORS_START_CHARGE_URL = (connectorId: number) =>
  `/chargepoints/connectors/${connectorId}/start_charge/` as const;
export const CONNECTORS_STOP_CHARGE_URL = (connectorId: number) =>
  `/chargepoints/connectors/${connectorId}/stop_charge/` as const;
